import { useState } from 'react';
import * as lib from '~/dependencies';

export default function useSingleRenderNotification() {
  const [hasNotified, setHasNotified] = useState(false);

  const showNotification = (
    type: 'error' | 'success',
    message: string,
    time?: number,
    options?: {}
  ) => {
    if (message && !hasNotified) {
      lib.ToastMessage(type, message, time, options);
      setHasNotified(true);
    }
  };

  const resetNotification = () => setHasNotified(false);

  return { showNotification, resetNotification };
}
